import {Controller} from '@stubhub/react-store-provider';

import {isRedirectModalEnabledSelector} from '../../store/gsConfig/FF/selectors';

const controller = new Controller({
  namespace: 'currencyExchange',
  mapStateToProps: (state) => {
    const deviceState = state.device || {};

    return {
      deviceType: deviceState.type,
      isRedirectModalEnabled: isRedirectModalEnabledSelector(state),
    };
  },
});

export default controller;
